exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#puzzle-container[data-v-360abaac]{height:100%;overflow:hidden;border-right:1px solid hsla(0,0%,100%,.3);border-bottom:1px solid hsla(0,0%,100%,.3);background-image:linear-gradient(90deg,hsla(0,0%,100%,.3) 1px,transparent 0),linear-gradient(180deg,hsla(0,0%,100%,.3) 1px,transparent 0)}.piece[data-v-360abaac]{position:absolute;background-size:cover;background-color:#fff;cursor:pointer;z-index:1}.piece[data-v-360abaac]:hover{outline:none;z-index:2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-360abaac","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Puzzle.vue
// module id = 28
// module chunks = 0